/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ComplianceControlPolicyUris extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ComplianceControlPolicyUris");
    }

    getFixupPrototypeFunction() { return ComplianceControlPolicyUris.fixupPrototype; }

    static newInstance(model: Partial<ComplianceControlPolicyUris>): ComplianceControlPolicyUris {
        let obj = Object.assign(new ComplianceControlPolicyUris(), model);
        ComplianceControlPolicyUris.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ComplianceControlPolicyUris>): ComplianceControlPolicyUris {
        if (!model) return null;
        return ComplianceControlPolicyUris.newInstance(<ComplianceControlPolicyUris> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ComplianceControlPolicyUris) {
        if (!obj) return;

        models.ComplianceControlPolicyUris.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ComplianceControlPolicyUris): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ComplianceControlPolicyUris.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Policy URIs to filter compliance controls
     */
    policy_uris: Array<string>;

}
